import z from "zod";

import { ChecklistTemplateShareSettingsOptions } from "../constants/checklist-template";

export const ChecklistTemplateFormSchema = z
  .object({
    name: z.string().min(1, "Name is required"),
    shareSettings: z
      .nativeEnum(ChecklistTemplateShareSettingsOptions)
      .nullable()
      .refine((val) => val !== null, {
        message: "Share settings is required",
      }),
    tasks: z.record(
      z.string(),
      z.object({
        name: z.string().min(1, "Name is required"),
        id: z.string().min(1, "ID is required"),
      }),
    ),
  })
  .superRefine((data, ctx) => {
    if (!Object.values(data.tasks).length) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["tasks"],
        message: "At least one task is required",
      });
    }
  });

export type ChecklistTemplateFormType = z.infer<typeof ChecklistTemplateFormSchema>;

export const CHECKLIST_TEMPLATE_INITIAL_VALUES: ChecklistTemplateFormType = {
  name: "",
  shareSettings: ChecklistTemplateShareSettingsOptions.Public,
  tasks: {},
};
